<!-- header start -->
<header class="sticky" [ngClass]="class" [class.fixed]="stick && sticky">
    <div class="mobile-fix-option"></div>
    <div class="top-header top-header-dark2" *ngIf="topbar">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="header-contact">
                        <ul>
                            <li>{{ "welcome-to" | translate : {orgName: orgName} }}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 text-right">
                    <ul class="header-dropdown">
                    <li class="compare">
                        <a [routerLink]="['/shop/compare']"><i class="fa fa-random" aria-hidden="true"></i>{{"Compare" | translate}}</a>
                        </li>
                        <li class="mobile-wishlist">
                        <a [routerLink]="['/shop/wishlist']"><i class="fa fa-heart" aria-hidden="true"></i>{{"wish-list" | translate}}</a>
                        </li>
                        <li class="onhover-dropdown mobile-account">
                        <i class="fa fa-user" aria-hidden="true"></i>{{"my-account" | translate}}
                        <ul class="onhover-show-div">
                            <li>
                            <a data-lng="en" (click)="loadTemplates()" translate>
                                load-templates
                            </a>
                            </li>
                            <li>
                            <a data-lng="en" (click)="deleteCart()" translate>
                                delete-cart
                            </a>
                            </li>
                            <li>
                            <a data-lng="es" (click)="signout()" translate>
                                log-out
                            </a>
                            </li>
                        </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container layout3-menu">
        <div class="row">
            <div class="col-sm-12">
                <div class="main-menu">
                    <div class="menu-left around-border">
                        <div class="main-menu-right">
                            <app-menu></app-menu>
                        </div>
                    </div>
                    <div class="absolute-logo">
                        <div class="brand-logo">
                            <a [routerLink]="['/home']">
                                <img [src]="themeLogo" alt="logo">
                            </a>
                        </div>
                    </div>
                    <div class="">
                        <div class="menu-right pull-right">
                            <div>
                                <app-settings></app-settings>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<!-- header end -->